module.exports = __webpack_public_path__ + "img/loginSign.360e4d43.png";